import React, { useState } from 'react';
import { GetAllCustomersFiltered_getAllCustomersFiltered as Customer } from '../../../types/schemaTypes';
import './CustomerItem.scss';
import DeleteModal from '../../../components/JobProfile/DeleteModal';

interface CustomerItemProps {
    customer: Customer;
    index: number;
    canEditCustomers: boolean;
    onEditClick: (customer: Customer) => void;
    onDelete?: (record: any) => void;
}

const CustomersItem = ({
    customer,
    index,
    onEditClick,
    onDelete,
    canEditCustomers,
}: CustomerItemProps): React.ReactElement => {
    const { customerName, description, extSystemIdentifier, enabled } = customer;
    const isOdd = index % 2 == 1;
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const containerStyle = `CustomersItem-Bottom-Container ${!isOdd &&
        'CustomersItem-Bottom-Container-With-Background'}`;
    const handleDelete = () => {
        onDelete && onDelete(customer);
        setDeleteConfirm(false);
    };

    return (
        <div className={containerStyle}>
            <div className="CustomersItem-List-Header">{customerName}</div>
            <div className="CustomersItem-List-Header">{description}</div>
            <div className="CustomersItem-List-Header">{extSystemIdentifier}</div>
            <div className="CustomersItem-List-Header">{enabled ? 'Active' : 'Inactive'}</div>
            {!canEditCustomers && <div className="GridViewItem-List-Header"></div>}
            {canEditCustomers && (
                <div className="GridViewItem-List-Header">
                    {canEditCustomers && (
                        <div
                            onClick={() => onEditClick(customer)}
                            className={` ${
                                canEditCustomers ? 'GridViewItem-Edit-Container' : 'GridViewItem-Edit-Container-Disable'
                            }`}
                        >
                            <i className="material-icons CustomersItem-Icon">edit</i>
                            <span className="UsersItem-Link">Edit</span>
                        </div>
                    )}
                    &nbsp;|&nbsp;
                    {canEditCustomers && onDelete && (
                        <div onClick={() => setDeleteConfirm(true)} className={` ${'GridViewItem-Edit-Container'}`}>
                            <i className="material-icons UsersItem-Icon">delete</i>
                            <span className="UsersItem-Link">Delete</span>
                        </div>
                    )}
                </div>
            )}
            <DeleteModal
                show={deleteConfirm}
                name={'customer'}
                onConfirm={handleDelete}
                onCancel={() => setDeleteConfirm(false)}
            />
        </div>
    );
};

export default CustomersItem;

